import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import { Toaster } from "./components/ui/sonner";
import AuthCallback from "./components/AuthCallback";
import Layout from "./components/Layout";
import LoginPage from "./pages/LoginPage";
import DashboardPage from "./pages/DashboardPage";
import CatalogPage from "./pages/CatalogPage";
import PreordersPage from "./pages/PreordersPage";
import ReleaseDetailPage from "./pages/ReleaseDetailPage";
import CollectionPage from "./pages/CollectionPage";
import WishlistPage from "./pages/WishlistPage";
import MissingPage from "./pages/MissingPage";
import AnalyticsPage from "./pages/AnalyticsPage";
import ProfilePage from "./pages/ProfilePage";
import TradeBoardPage from "./pages/TradeBoardPage";
import PublicProfilePage from "./pages/PublicProfilePage";
import LeaderboardPage from "./pages/LeaderboardPage";
import DiscoverPage from "./pages/DiscoverPage";
import WrappedPage from "./pages/WrappedPage";
import ArchetypeLandingPage from "./pages/ArchetypeLandingPage";
import BrandIndexPage from "./pages/BrandIndexPage";
import BrandDetailPage from "./pages/BrandDetailPage";
import BillingPage, { BillingSuccessRedirect } from "./pages/BillingPage";
import BulkImportPage from "./pages/BulkImportPage";
import ShelfScanPage from "./pages/ShelfScanPage";
import ShowcasesPage from "./pages/ShowcasesPage";
import ShowcaseDetailPage from "./pages/ShowcaseDetailPage";

function AppRouter() {
  const location = useLocation();

  // Check URL fragment for session_id synchronously during render (prevents race conditions)
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }

  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register" element={<LoginPage isRegister />} />
      <Route path="/collector/:slug" element={<PublicProfilePage />} />
      <Route path="/c/:slug/archetype" element={<ArchetypeLandingPage />} />
      <Route path="/brands" element={<BrandIndexPage />} />
      <Route path="/brands/:slug" element={<BrandDetailPage />} />
      <Route path="/" element={<Navigate to="/dashboard" replace />} />
      <Route path="/dashboard" element={<Layout><DashboardPage /></Layout>} />
      <Route path="/catalog" element={<Layout><CatalogPage /></Layout>} />
      <Route path="/preorders" element={<Layout><PreordersPage /></Layout>} />
      <Route path="/catalog/:id" element={<Layout><ReleaseDetailPage /></Layout>} />
      <Route path="/collection" element={<Layout><CollectionPage /></Layout>} />
      <Route path="/wishlist" element={<Layout><WishlistPage /></Layout>} />
      <Route path="/trades" element={<Layout><TradeBoardPage /></Layout>} />
      <Route path="/missing" element={<Layout><MissingPage /></Layout>} />
      <Route path="/analytics" element={<Layout><AnalyticsPage /></Layout>} />
      <Route path="/leaderboard" element={<Layout><LeaderboardPage /></Layout>} />
      <Route path="/discover" element={<Layout><DiscoverPage /></Layout>} />
      <Route path="/profile" element={<Layout><ProfilePage /></Layout>} />
      <Route path="/wrapped" element={<WrappedPage />} />
      <Route path="/billing" element={<Layout><BillingPage /></Layout>} />
      <Route path="/billing/success" element={<BillingSuccessRedirect />} />
      <Route path="/import" element={<Layout><BulkImportPage /></Layout>} />
      <Route path="/shelf-scan" element={<Layout><ShelfScanPage /></Layout>} />
      <Route path="/showcases" element={<Layout><ShowcasesPage /></Layout>} />
      <Route path="/showcases/:showcase_id" element={<Layout><ShowcaseDetailPage /></Layout>} />
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRouter />
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
